import { FaRegClock } from 'react-icons/fa';
import { BiFilterAlt } from 'react-icons/bi';
import { useState } from 'react';
import MobileHistory from '@/components/home/mobile/History/MobileHistory';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import HistoryFilters from './HistoryFilters';
interface Props {
  orderId: string;
}
export default function MobileHistoryLayout(p: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  function toggleModal() {
    setIsModalOpen(!isModalOpen);
  }
  return <div className={`bg-genius-indigo h-screen flex flex-col mt-4`} data-sentry-component="MobileHistoryLayout" data-sentry-source-file="MobileHistoryLayout.tsx">
      <div className='ta-l items-center w-full'>
        <div className='flex items-center  justify-between w-full'>
          <div className='w-1/3 pl-2'>
            <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="MobileHistoryLayout.tsx" />
          </div>

          <div className='w-1/3'>
            <p className='text-genius-cream/50 text-[16px] flex justify-center'>
              <FaRegClock className='text-genius-cream h-[22px] w-[22px] mr-2' data-sentry-element="FaRegClock" data-sentry-source-file="MobileHistoryLayout.tsx" />
              History
            </p>
          </div>

          <div className='w-1/3 flex items-center ta-r justify-end'>
            <div onClick={() => toggleModal()} className='text-[20px] flex items-center justify-center mr-4 bg-genius-blue rounded-lg h-[32px] w-[32px]'>
              <BiFilterAlt className={`text-genius-cream`} width={20} height={18} data-sentry-element="BiFilterAlt" data-sentry-source-file="MobileHistoryLayout.tsx" />
            </div>
          </div>
        </div>
      </div>

      <div className='flex-1 w-full'>
        <MobileHistory orderId={p.orderId} data-sentry-element="MobileHistory" data-sentry-source-file="MobileHistoryLayout.tsx" />
      </div>
      <HistoryFilters isModalOpen={isModalOpen} toggleModal={toggleModal} data-sentry-element="HistoryFilters" data-sentry-source-file="MobileHistoryLayout.tsx" />
    </div>;
}